import React, { useEffect } from "react"
import {
  SelectChangeEvent,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Box,
} from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import {
  getCategoryList,
  getSubCategoryList,
  getSubCategoryList1,
  selectTransactions,
} from "../../slices/transactionsSlice"
import { RefreshRounded } from "@mui/icons-material"
import {
  PrimaryButton,
  StyledButton,
  StyledFormControl,
} from "../Transactions/styles"
import {
  CategoriesState,
  CategoryFilterType,
  selectCategories,
  setCategoryFilters,
} from "../../slices/categorySlice"
interface CategoryFiltersProps {
  category: keyof CategoriesState
  resetFilterHandler: () => void
  ApplyFilterHandler: () => void
}

const CategoryFilters: React.FC<CategoryFiltersProps> = ({
  category,
  resetFilterHandler,
  ApplyFilterHandler,
}) => {
  const { filters } = useAppSelector(
    (state) => selectCategories(state)[category],
  )

  const categoryLevel = Number(category.replace("Category", ""))

  const showParentCategory = categoryLevel > 1
  const showParentSubCategory = categoryLevel > 2

  const { categoryList: filterCategoryList, subCategoryList } =
    useAppSelector(selectTransactions)
  const dispatch = useAppDispatch()

  useEffect(() => {
    showParentCategory &&
      filterCategoryList.length === 0 &&
      dispatch(getCategoryList({}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    filters.category1 &&
      dispatch(getSubCategoryList({ level1: filters.category1 }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.category1])

  useEffect(() => {
    filters.category2 &&
      dispatch(
        getSubCategoryList1({
          level1: filters.category1,
          level2: filters.category2,
        }),
      )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.category2])

  const handleSourceChange = (e: SelectChangeEvent) => {
    const newFilters: CategoryFilterType = {
      ...filters,
      source: e.target.value as string,
    }
    dispatch(setCategoryFilters({ category, filters: newFilters }))
  }
  const handleCategoryChange = (e: SelectChangeEvent) => {
    const newFilters: CategoryFilterType = {
      ...filters,
      category1: e.target.value as string,
    }
    dispatch(setCategoryFilters({ category, filters: newFilters }))
  }
  const handleSubCategoryChange = (e: SelectChangeEvent) => {
    const newFilters: CategoryFilterType = {
      ...filters,
      category2: e.target.value as string,
    }
    dispatch(setCategoryFilters({ category, filters: newFilters }))
  }

  return (
    <Stack direction="column" gap={2}>
      <StyledFormControl size="small">
        <InputLabel id="source-label">Source</InputLabel>
        <Select
          labelId="source-label"
          id="source-select"
          label="Source"
          name="source"
          required
          value={filters.source}
          onChange={handleSourceChange}
        >
          <MenuItem value="alts">Alts</MenuItem>
          <MenuItem value="workspace">Workspace</MenuItem>
        </Select>
      </StyledFormControl>
      {showParentCategory && (
        <StyledFormControl size="small">
          <InputLabel id="select-opertator">Category</InputLabel>
          <Select
            labelId="select-opertator"
            id="selectOperator"
            label="Operator"
            value={filters.category1}
            onChange={handleCategoryChange}
          >
            {filterCategoryList.length > 0 ? (
              filterCategoryList.map((category) => (
                <MenuItem value={category?.id}>{category?.value}</MenuItem>
              ))
            ) : (
              <MenuItem value="" disabled>
                No options available
              </MenuItem>
            )}
          </Select>
        </StyledFormControl>
      )}
      {showParentSubCategory && (
        <StyledFormControl size="small">
          <InputLabel id="select-category2">Sub-Cat</InputLabel>
          <Select
            labelId="select-category2"
            id="category2"
            label="Sub-Cat"
            value={filters.category2}
            onChange={handleSubCategoryChange}
            disabled={!filters.category1}
          >
            {subCategoryList.length > 0 ? (
              subCategoryList.map((category) => (
                <MenuItem value={category?.id}>{category?.value}</MenuItem>
              ))
            ) : (
              <MenuItem value="" disabled>
                No options available
              </MenuItem>
            )}
          </Select>
        </StyledFormControl>
      )}
      <Box sx={{ display: "flex", gap: "10px", flex: 1 }}>
        <StyledButton
          sx={{ width: "100%" }}
          variant="outlined"
          startIcon={<RefreshRounded fontSize="small" />}
          color="inherit"
          onClick={resetFilterHandler}
        >
          Reset
        </StyledButton>
        <PrimaryButton
          sx={{ width: "100%" }}
          variant="contained"
          onClick={ApplyFilterHandler}
        >
          Apply
        </PrimaryButton>
      </Box>
    </Stack>
  )
}

export default CategoryFilters
